import CityPanel from '../ProtectPages/AdminPanel/CityPanel/CityPanel'
import ColorPanel from '../ProtectPages/AdminPanel/ColorPanel/ColorPanel'
import AddColor from '../ProtectPages/AdminPanel/ColorPanel/AddColor'
import EditColor from '../ProtectPages/AdminPanel/ColorPanel/EditColor'
import HotelPanel from '../ProtectPages/AdminPanel/HotelPanel/HotelPanel'
import AddHotel from '../ProtectPages/AdminPanel/HotelPanel/AddHotel'
import EditHotel from '../ProtectPages/AdminPanel/HotelPanel/EditHotel'
import PlanPanel from '../ProtectPages/AdminPanel/PlanPanel/PlanPanel'
import AddPlan from '../ProtectPages/AdminPanel/PlanPanel/AddPlan'
import EditPlan from '../ProtectPages/AdminPanel/PlanPanel/EditPlan'
import PlanAttachmentPanel from '../ProtectPages/AdminPanel/PlanAttachmentPanel/PlanAttachmentPanel'
import { InitialPlan } from '../ProtectPages/AdminPanel/PlanPanel/InitialPlan'
import AirlinePanel from '../ProtectPages/AdminPanel/AirlinePanel/AirlinePanel'
import CompanyPanel from '../ProtectPages/AdminPanel/CompanyPanel/CompanyPanel'
import FlightStationPanel from "../ProtectPages/AdminPanel/FlightStationPanel/FlightStationPanel"
import ProvincePanel from '../ProtectPages/AdminPanel/ProvincePanel/ProvincePanel'
import PriceGroupPanel from '../ProtectPages/AdminPanel/PriceGroupPanel/PriceGroupPanel'
import BrokerPanel from '../ProtectPages/AdminPanel/BrokerPanel/BrokerPanel'
import { AddInitialPlan } from '../ProtectPages/AdminPanel/PlanPanel/AddInitialPlan'
import ChangePassword from '../ProtectPages/UserPanel/ChangePassword'
import InitialPlanList from '../ProtectPages/AdminPanel/PlanPanel/InitialPlanList'
import EditInitialPlan from '../ProtectPages/AdminPanel/PlanPanel/EditInitialPlan'

import AddPlanAttachment from '../ProtectPages/AdminPanel/PlanAttachmentPanel/AddPlanAttachment'
import PlanAttachmentList from '../ProtectPages/AdminPanel/PlanAttachmentPanel/PlanAttachmentList'
import HotelStructureList from '../ProtectPages/AdminPanel/HotelStructure/HotelStructureList'
import AutoDesignHotel from '../ProtectPages/AdminPanel/HotelStructure/AutoDesignHotel'
import PlanErrorLogList from '../ProtectPages/AdminPanel/ErrorLogPanel/PlanErrorLogList'
import UpdatePlanToLast from '../ProtectPages/AdminPanel/PlanPanel/UpdatePlanToLast'
import PlanInfoList from '../ProtectPages/AdminPanel/PlanPanel/PlanInfoList'
import OverRoom from '../ProtectPages/AdminPanel/PlanPanel/OverRoom'


const PrivateRoutList = [
    {
        name: 'ChangePassword',
        path: 'User/changePassword',
        element: <ChangePassword />
    },
    {
        name: 'CityPanel',
        path: 'CityPanel',
        element: <CityPanel />
    },
    {
        name: 'ColorPanel',
        path: 'ColorPanel',
        element: <ColorPanel />
    },
    {
        name: 'Color:Add',
        path: 'Color/Add',
        element: <AddColor />
    },
    {
        name: 'Color:Edit',
        path: 'Color/Edit/:id',
        element: <EditColor />
    },
    {
        name: 'HotelPanel',
        path: 'HotelPanel',
        element: <HotelPanel />
    },
    {
        name: 'Hotel:Add',
        path: 'Hotel/Add',
        element: <AddHotel />
    },
    {
        name: 'Hotel:Edit',
        path: 'Hotel/Edit/:id',
        element: <EditHotel />
    },
    {
        name: 'AutoDesignHotel',
        path: 'AutoDesignHotel',
        element: <AutoDesignHotel />
    },
    {
        name: 'PlanPanel',
        path: 'PlanPanel',
        element: <PlanPanel />
    },
    {
        name: 'Plan:Add',
        path: 'Plan/add',
        element: <AddPlan />
    },
    {
        name: 'Plan:Edit',
        path: 'Plan/edit',
        element: <EditPlan />
    },
    {
        name: 'InitialPlan:Add',
        path: 'InitialPlan/Add',
        element: <AddInitialPlan />
    },
    {
        name: 'InitialPlan',
        path: 'Plan/initial',
        element: <InitialPlan />
    },
    {
        name: 'InitialPlanList',
        path: 'InitialPlan/List',
        element: <InitialPlanList />
    },
    {
        name: 'InitialPlan:Edit',
        path: 'InitialPlan/edit/:id',
        element: <EditInitialPlan />
    },
    {
        name: 'PlanAttachmentPanel',
        path: 'PlanAttachmentPanel',
        element: <PlanAttachmentPanel />
    },
    {
        name: 'PlanAttachment:Add',
        path: 'PlanAttachment/Add',
        element: <AddPlanAttachment />
    },
    {
        name: 'PlanAttachmentList',
        path: 'PlanAttachment/List',
        element: <PlanAttachmentList />
    },
    {
        name: 'AirlinePanel',
        path: 'AirlinePanel',
        element: <AirlinePanel />
    },
    {
        name: 'CompanyPanel',
        path: 'CompanyPanel',
        element: <CompanyPanel />
    }
    ,
    {
        name: 'FlightStationPanel',
        path: 'FlightStationPanel',
        element: <FlightStationPanel />
    }
    ,
    {
        name: 'ProvincePanel',
        path: 'ProvincePanel',
        element: <ProvincePanel />
    },
    {
        name: 'PriceGroupPanel',
        path: 'PriceGroupPanel',
        element: <PriceGroupPanel />
    },
    {
        name: 'BrokerPanel',
        path: 'BrokerPanel',
        element: <BrokerPanel />
    },
    {
        name: 'HotelStructure:List',
        path: 'HotelStructure/List/:id',
        element: <HotelStructureList />
    },
    {
        name: 'PlanErrorLogList',
        path: 'PlanErrorLog/List',
        element: <PlanErrorLogList />
    },
    {
        name: 'Reservation:UpdatePlanToLast',
        path: 'InitialPlan/UpdatePlanToLast',
        element: <UpdatePlanToLast />
    },
    {
        name: 'PlanInfoList',
        path: 'PlanInfo/List',
        element: <PlanInfoList />
    },
    {
        name: 'OverRoom',
        path: 'OverRoom',
        element: <OverRoom />
    },
];
export default PrivateRoutList;

